import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  routes: [
  {
      path: '/',
      component: ()=> import ('@/components/login/login.vue'), 
      meta: {
        nameComponent: 'login'
      }
  },
  {
      path: '/access',
      name: 'access',      
      component: ()=> import ('@/components/access/access.vue'), 
      meta: {
        nameComponent: 'access',
      }
  },     
  {
      path: '/login',
      name: 'login',      
      component: ()=> import ('@/components/applogin.vue'), 
      meta: {
        nameComponent: 'applogin',
      }
  },       
  {
    path: '/logout',
    name: 'logout',      
    component: ()=> import ('@/components/logout.vue'), 
    meta: {
      nameComponent: 'logout',
    }
  },       
   
  ]
})
router.beforeEach((to, from, next) => {    
  next()
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js